module.exports = __webpack_public_path__ + "MapStore2/web/client/product/assets/img/made-in-italy-logo.png";